var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { MessageUIRequest, MessageUIRequestType } from "@/share/Message";
import { DateLib } from "@@/Datelib";
import { LetrboxDocument, LetrboxDocumentStatus, LetrboxImage, MessageDeliveryStatus, MessageType, Text } from "@@/Message";
import { action, makeObservable, observable } from "mobx";
export class RepliesUIStore {
    constructor() {
        this.open = false;
        this.mainmessageid = "";
        this.loadingReplies = false;
        this.loadingMore = false;
        this.repliesById = new Map();
        this.lastCount = -1;
        this.edittingMessageId = "";
        this.editingHtml = "";
        this.savingedit = false;
        this.letrid = "";
        this.lastReplyTime = 0;
        this.scrollToId = '';
        this.zIndex = 100;
        this.replyLoadCount = 10000;
        makeObservable(this);
        APPEvent.addSubscriberForActiveLetr(l => {
            this.reset();
            this.letrid = l;
        });
        APPEvent.addSubscriberForMessageResponse((res) => {
            if (res.type === MessageUIRequestType.FetchReplies) {
                res.msg.forEach((m) => this.addReply(m));
                if (res.msg.length < this.replyLoadCount) {
                    this.setLastCount(0);
                }
                else {
                }
            }
            else if (res.type === MessageUIRequestType.AddReply) {
                console.log(res.replaceId);
                const replacemsg = this.repliesById.get(res.replaceId);
                if (replacemsg !== undefined) {
                    this.removeMessage(replacemsg);
                }
                res.msg.forEach((m) => {
                    console.log(m);
                    this.addReply(m);
                });
            }
            else if (res.type === MessageUIRequestType.EditReply) {
                if (res.msg.length > 0) {
                    const pmsg = this.repliesById.get(res.replaceId);
                    if (pmsg !== undefined) {
                        this.removeMessage(pmsg);
                    }
                    this.addReply(res.msg[0]);
                }
                this.setSavingEdit(false);
                this.setEditMessageId("");
            }
            this.setLoading(false);
            this.setLoadingMore(false);
        });
        APPEvent.addSubscriberDeleteReply((res) => {
            const pmsg = this.repliesById.get(res.reply._id);
            if (pmsg !== undefined) {
                this.removeMessage(pmsg);
            }
        });
        APPEvent.addSubscriberForNewLetr(() => {
            this.reset();
        });
    }
    setActiveMessageId(id) {
        this.mainmessageid = id;
    }
    setZIndex(zindex) {
        this.zIndex = zindex;
    }
    setEditMessageId(id) {
        if (this.savingedit) {
            return;
        }
        this.edittingMessageId = id;
        const msg = this.repliesById.get(id);
        if (msg !== undefined) {
            this.setEditText(msg.text);
        }
        else {
            this.setEditText("");
        }
    }
    setEditText(text) {
        this.editingHtml = text;
    }
    setScrollToId(id) {
        this.scrollToId = id;
    }
    setSavingEdit(save) {
        this.savingedit = save;
    }
    removeMessage(msg) {
        this.repliesById.delete(msg._id);
    }
    setLastCount(count) {
        this.lastCount = count;
    }
    getMessageTime(msg) {
        return DateLib.getTodayTimeOrDate(msg.createdAt);
    }
    addReply(m) {
        this.repliesById.set(m._id, m);
        if (m.createdAt > this.lastReplyTime) {
            this.lastReplyTime = m.createdAt;
        }
    }
    setMainMessage(mainMessage) {
        this.mainMessage = mainMessage;
        this.reset();
    }
    setActiveLetrid(letrid) {
        this.letrid = letrid;
    }
    loadMoreReplies() {
        if (this.letrid === "" || this.loadingMore ||
            this.loadingReplies || this.mainMessage === undefined || this.lastCount === 0) {
            return;
        }
        this.setLoadingMore(true);
        const req = new MessageUIRequest();
        req.letrid = this.letrid;
        req.count = this.replyLoadCount;
        req.parentid = this.mainMessage._id;
        req.type = MessageUIRequestType.FetchReplies;
        req.sortAsc = true;
        req.time = this.lastReplyTime;
        this.requestMessages(req);
    }
    loadReplies() {
        if (this.letrid === ""
            || this.loadingMore
            || this.loadingReplies || this.mainMessage === undefined
            || this.lastCount === 0) {
            return;
        }
        this.setLoading(true);
        const req = new MessageUIRequest();
        req.letrid = this.letrid;
        req.count = this.replyLoadCount;
        req.parentid = this.mainMessage._id;
        req.type = MessageUIRequestType.FetchReplies;
        req.sortAsc = true;
        req.time = 0;
        this.requestMessages(req);
    }
    sendImageMessage(file, authorname) {
        var _a, _b;
        const dmessage = new LetrboxImage(Math.random() + "", this.letrid, "", new Date().getTime(), { _id: "", name: authorname }, LetrboxDocumentStatus.Uploaded, file.size);
        dmessage.accesskey = file.accesskey;
        dmessage.accesscode = file.databoxid;
        dmessage.documentreference = file.fileid;
        dmessage.width = (_a = file.width) !== null && _a !== void 0 ? _a : 0;
        dmessage.height = (_b = file.height) !== null && _b !== void 0 ? _b : 0;
        this.addReply(dmessage);
        this.sendMessage(dmessage);
    }
    sendDocumentmessage(file, authorname) {
        const dmessage = new LetrboxDocument(Math.random() + "", this.letrid, "", new Date().getTime(), { _id: "", name: authorname }, LetrboxDocumentStatus.Uploaded, file.filename);
        dmessage.accesskey = file.accesskey;
        dmessage.accesscode = file.databoxid;
        dmessage.documentreference = file.fileid;
        dmessage.size = file.size;
        dmessage.name = file.filename;
        dmessage.versions = [];
        dmessage.versions.push({
            name: file.filename,
            isDownloadable: file.isDownloadable,
            filid: file.fileid,
            boxid: file.databoxid,
            versionnumber: 1,
            acesskey: file.accesskey,
            size: file.size,
            creatorid: ''
        });
        this.addReply(dmessage);
        this.sendMessage(dmessage);
    }
    createTextMessage(text, authorname) {
        const id = Math.random() + "";
        const tmessage = new Text(id, this.letrid, "", new Date().getTime(), { _id: "", name: authorname }, text);
        tmessage.isHtml = true;
        tmessage.setstatus(MessageDeliveryStatus.Activating);
        this.addReply(tmessage);
        this.sendMessage(tmessage);
    }
    sendMessage(msg) {
        if (this.mainMessage === undefined) {
            return;
        }
        const req = new MessageUIRequest();
        req.type = MessageUIRequestType.AddReply;
        req.letrid = this.letrid;
        req.parentid = this.mainMessage._id;
        req.replaceId = msg._id;
        req.msgs = msg;
        req.time = this.lastReplyTime;
        this.requestMessages(req);
    }
    saveEditMessage() {
        if (!this.edittingMessageId) {
            return;
        }
        const msg = this.repliesById.get(this.edittingMessageId);
        if (msg === undefined || msg.type !== MessageType.Text) {
            return;
        }
        this.setSavingEdit(true);
        msg.text = this.editingHtml;
        msg.letrid = this.letrid;
        this.editMessage(msg);
    }
    editMessage(msg) {
        if (this.repliesById.has(msg._id)) {
            const req = new MessageUIRequest();
            req.type = MessageUIRequestType.EditReply;
            req.letrid = this.letrid;
            req.replaceId = msg._id;
            req.msgs = msg;
            this.requestMessages(req);
        }
    }
    deleteMessage(id) {
        const msg = this.repliesById.get(id);
        if (msg === undefined) {
            return;
        }
        this.removeMessage(msg);
        const req = new MessageUIRequest();
        req.type = MessageUIRequestType.DeleteReply;
        req.letrid = this.letrid;
        req.replaceId = msg._id;
        req.msgs = msg;
        this.requestMessages(req);
    }
    getReplies() {
        return Array.from(this.repliesById.values()).sort(this.sortByTime);
    }
    sortByTime(t1, t2) {
        return t1.createdAt - t2.createdAt;
    }
    requestMessages(req) {
        Apphandler.sendMessage("messages", req);
    }
    setLoading(loading) {
        this.loadingReplies = loading;
    }
    setLoadingMore(loading) {
        this.loadingMore = loading;
    }
    setOpen(open) {
        this.open = open;
    }
    reset() {
        this.repliesById = new Map();
        this.lastReplyTime = 0;
        this.scrollToMessage = undefined;
        this.zIndex = 0;
        this.setActiveMessageId("");
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "mainMessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "mainmessageid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "loadingReplies", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "loadingMore", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], RepliesUIStore.prototype, "repliesById", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "lastCount", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "edittingMessageId", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "editingHtml", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "savingedit", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], RepliesUIStore.prototype, "scrollToId", void 0);
__decorate([
    observable,
    __metadata("design:type", Number)
], RepliesUIStore.prototype, "zIndex", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setActiveMessageId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setZIndex", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setEditMessageId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setEditText", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setScrollToId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setSavingEdit", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "removeMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setLastCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "addReply", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setMainMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setActiveLetrid", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], RepliesUIStore.prototype, "reset", null);
